import { gql } from 'apollo-angular';
import { QualityDoc } from './qualityDocs.graphql';

export const AssayDocument = {
  fragments: {
    AssayDocument: gql`
      fragment AssayDocument on AssayDocument {
        id
        assayId
        assayAnaliteId
        qualityDocumentId
        role
        notes
        created
        updated
        v_
        qualityDocument {
          ...QualityDoc
        }
        assayAnalite {
          id
          importReference
          analite {
            id
            name
            code
          }
        }
      }
      ${QualityDoc.fragments.QualityDoc}
    `
  }
};

export const Get_AssayDocuments = gql`
  query GetAssayDocuments($assayId: String, $assayAnaliteId: String, $generalOnly: Boolean) {
    assayDocuments(assayId: $assayId, assayAnaliteId: $assayAnaliteId, generalOnly: $generalOnly) {
      ...AssayDocument
    }
  }
  ${AssayDocument.fragments.AssayDocument}
`;

export const Link_AssayDocument = gql`
  mutation LinkAssayDocument($data: LinkAssayDocumentInput!) {
    linkAssayDocument(data: $data) {
      ...AssayDocument
    }
  }
  ${AssayDocument.fragments.AssayDocument}
`;

export const Unlink_AssayDocument = gql`
  mutation UnlinkAssayDocument($id: String!) {
    unlinkAssayDocument(id: $id) {
      ...AssayDocument
    }
  }
  ${AssayDocument.fragments.AssayDocument}
`;

export const Update_AssayDocument = gql`
  mutation UpdateAssayDocument($id: String!, $data: UpdateAssayDocumentInput!) {
    updateAssayDocument(id: $id, data: $data) {
      ...AssayDocument
    }
  }
  ${AssayDocument.fragments.AssayDocument}
`;
